export default __webpack_public_path__ + "static/media/Montserrat-ExtraLight.ddc3ab52.ttf";